<template>
    <qrcode-vue :value="value" :size="size" :margin="margin" level="H" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import QrcodeVue from "qrcode.vue";

export default defineComponent({
    name: "Qrcode",
    components: {
        QrcodeVue
    },
    data() {
        return {
            value: "",
            size: 250,
            margin: 2
        };
    }
});

</script>